import { TaxLiabilityDataResponseType } from '../../../types/mutual-fund-detail.types'
import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'

type TaxLiabilityData = TaxLiabilityDataResponseType & {
  preTaxValue?: number
  taxLiability?: number
  postTaxValue?: number
}

/**
 * Checks if the fund type is ELSS
 */
export const isELSSFund = (fundType?: string): boolean => {
  return fundType?.toLowerCase() === 'elss'
}

/**
 * Gets the redeemable value for ELSS funds
 */
export const getRedeemableValue = (taxLiabilityData: TaxLiabilityData): number => {
  return (taxLiabilityData?.ltcgTaxInfo?.investedAmount ?? 0) + (taxLiabilityData?.ltcgTaxInfo?.gains ?? 0)
}

/**
 * Gets the tax description text based on fund type
 */
export const getTaxDescriptionText = (taxLiabilityData: TaxLiabilityData): string => {
  if (isELSSFund(taxLiabilityData?.fundType)) {
    const redeemableValue = getRedeemableValue(taxLiabilityData)
    return `on ${roundOffAndFormatNumberWithCurrency(redeemableValue)} redeemable value`
  }
  return 'upon redemption'
}

/**
 * Gets the info text below the value table based on fund type
 */
export const getInfoText = (fundType?: string): string => {
  if (isELSSFund(fundType)) {
    return '3Y lock-in completed'
  }
  return 'This gets credited to your bank'
}

export type { TaxLiabilityData }
